import { render, staticRenderFns } from "./CompleteProvideForRegistryPoInstructions.vue?vue&type=template&id=1d6af736"
import script from "./CompleteProvideForRegistryPoInstructions.vue?vue&type=script&lang=ts"
export * from "./CompleteProvideForRegistryPoInstructions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports